// ===== K-Tec Business Settings Store =====
// Persists: business profile, admin password, logo
// localStorage key: ktec-business-settings

import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';

export interface BusinessSettings {
  businessName: string;
  logo: string | null;         // base64 data URL or CDN URL
  phone: string;
  whatsappNumber: string;      // international format e.g. 94702161323
  address: string;
  mapsLink: string;            // Google Maps embed URL or place URL
  tagline: string;
  email: string;
  website: string;
  vatNumber: string;
  taxRate: number;
  currency: string;
}

interface BusinessSettingsStore {
  settings: BusinessSettings;
  adminPassword: string;
  adminPin: string;
  updateSettings: (data: Partial<BusinessSettings>) => void;
  changeAdminPassword: (newPassword: string) => void;
  changeAdminPin: (newPin: string) => void;
  verifyAdminPassword: (password: string) => boolean;
}

const defaultSettings: BusinessSettings = {
  businessName: 'K-Tec Engineering (Pvt) Ltd',
  logo: null,
  phone: '076 282 9800',
  whatsappNumber: '94702161323',
  address: 'Kandy, Sri Lanka',
  mapsLink: '',
  tagline: 'Professional Security & Technology Solutions',
  email: 'info@k-tec.lk',
  website: 'www.k-tec.lk',
  vatNumber: 'VAT12345678',
  taxRate: 0,
  currency: 'LKR',
};

export const useBusinessSettingsStore = create<BusinessSettingsStore>()(
  persist(
    (set, get) => ({
      settings: defaultSettings,
      adminPassword: 'admin123',
      adminPin: '2025',

      updateSettings: (data) =>
        set((s) => ({ settings: { ...s.settings, ...data } })),

      changeAdminPassword: (newPassword) =>
        set({ adminPassword: newPassword }),

      changeAdminPin: (newPin) =>
        set({ adminPin: newPin }),

      verifyAdminPassword: (password) =>
        get().adminPassword === password,
    }),
    {
      name: 'ktec-business-settings',
      storage: createJSONStorage(() => localStorage),
    }
  )
);
